
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { Observer } from 'mobx-vue'

type StudyActionData = {
  piece: number
  time: number
  action: number
  userInfo: {
    username: string
    userId: number
  }
}

@Observer
@Component({
  components: {
    HeaderImage
  }
})
export default class SummaryActionData extends Vue {
  get PageStore() {
    return this.$store.$courseV2.Summary
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
